import {Collection} from '@blesk-frontend/api';
import {Docs, Pill} from '@blesk-frontend/ui';

import {RenderGrid} from '@/features/guides';
import {CollectionFillButton} from '../CollectionFillModal';
import {CollectionForm, CollectionFormData} from './CollectionForm';

interface CollectionViewProps {
  collection: Collection;
  onSubmit: (data: CollectionFormData) => Promise<void>;
}

export const CollectionView = ({collection, onSubmit}: CollectionViewProps) => {
  return (
    <div className="container mx-auto flex h-[calc(100%-113px)] max-w-screen-xl flex-col outline-0">
      <div className="prose prose-sm md:prose-base w-full max-w-3xl">
        <div className="mb-4 flex items-center gap-4 md:mb-6">
          <Pill>{collection.user.fullName}</Pill>
          <div className="text-paragraph-sm text-text-secondary">
            Инструкций: {collection._count.guides}
          </div>
        </div>
        <CollectionForm collection={collection} onSubmit={onSubmit} />
      </div>

      {collection.guides.length ? (
        <RenderGrid isLoading={false} guides={collection.guides.map((g) => g.guide)} />
      ) : (
        <div className="h-full rounded-lg border bg-bg-primary">
          <div className="mx-auto flex size-full max-w-xs flex-col items-center justify-center gap-6">
            <div className="flex flex-col items-center justify-center gap-3 text-center text-paragraph-lg text-text-secondary">
              <Docs className="size-16" />
              <p>
                Выберите инструкции, которые
                <br /> должны войти в данную коллекцию
              </p>
            </div>
            <CollectionFillButton collection={collection} />
          </div>
        </div>
      )}
    </div>
  );
};
